<template>
  <footer id="footer" >
    <div class="section columns">
      <div class="column is-one-third is-full-mobile">
        <img src="@/assets/img/logoUIAP.png" alt="Logo de la UIAP ENP UNAM">
        <h2 class="has-text-centered">
          UNIDAD DE INVESTIGACIÓN <br>
          Y APOYO PEDAGÓGICO
        </h2>
        <!--
          <p>
            Vivamus malesuada vulputate metus nec vulputate. Nullam libero mauris,
            condimentum consequat eros in, pharetra tincidunt metus.
          </p>
        -->
      </div>
      <div class="column is-one-third is-full-mobile">
        <div>
          <h2>Sitios de interés</h2>
          <ul>
            <li>
              <a href="https://www.unam.mx/">Universidad Nacional Autónoma de México</a>
            </li>
            <li>
              <a href="http://enp.unam.mx/">Escuela Nacional Preparatoria</a>
            </li>
            <li>
              <a href=""></a>
            </li>
            <li>
              <a href=""></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="column is-one-third is-full-mobile">
        <div>
          <h2>Contacto</h2>
          <ul>
            <li>
              <a
                target="_blank"
                href="https://www.google.com/maps/place/Direcci%C3%B3n+General+de+la+Escuela+Nacional+Preparatoria+UNAM/@19.3905196,-99.1700494,17z/data=!3m1!4b1!4m5!3m4!1s0x85d1ff7355e83499:0x89c9d4907d8a3e7f!8m2!3d19.3905196!4d-99.1678607"
              >
                <i class="fas fa-map-marker"></i>
                Primer piso en Adolfo Prieto 722, Col del Valle Nte, Benito Juárez,
                03100 Ciudad de México, CDMX
              </a>
            </li>
            <li>
              <a href="tel:5556876858">
                <i class="fas fa-phone-alt"></i>
                Conmutador 55-5687-6858/68/78/88
              </a>
            </li>
            <li>
              <a href="mailto:uiap.informes@enp.unam.mx ">
                <i class="fa-solid fa-envelope"></i>
                uiap.informes@enp.unam.mx
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="section columns">
      <div class="column">
        <p>
          Unidad de Investigación y Apoyo Pedagógico.
          Todos los derechos reservados 2021.
          Hecho en México.<br>
          Aviso de privacidad
          [<a target="_blank" href="http://enp.unam.mx/assets/pdf/aviso-privacidad/SIMPLIFICADO.pdf">Simplificado</a> | <a target="_blank" href="http://enp.unam.mx/assets/pdf/aviso-privacidad/INTEGRAL.pdf">Integral</a>]
          <br>
          <router-link to="/creditos">Créditos</router-link>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'MainFooter',
};
</script>
<style lang="scss">
  @import '@/assets/styles/colors.scss';
  footer{
    background-color: $uiap-primary;
  }
  #footer *{
    color: #fff;
    text-align: left;
  }
  #footer h2{
    font-size: 20px;
    margin-bottom: 10px;
  }
  #footer img{
    max-width: 50%;
  }
  #footer a{
    text-decoration: underline;
  }
  #footer a:hover {
    color: $link-hover;
  }

  #footer> :last-child{
    border-top: 1px solid $green-light;
  }

  #footer :last-child{
    margin-bottom: 0;
  }
  #footer > :first-child > *{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  @media (min-width: 768px){
    #footer img{
      max-width: 20%;
    }
  }
</style>
